<template>
  <div class="no-resource-body-wrap flex-col">
    <div class="no-resource-row">
      <span class="text-sm">{{ translate('addCardsThatContributeToProject') }}</span>
    </div>
    <div
      class="no-resource-row"
      :class="{ 'flex-col': isMobile }"
    >
      <ButtonCustom
        class="pointer-events-auto"
        type="important-custom"
        :text="translate('addNewCard').toLowerCase()"
        :custom-icon-name="'plus'"
        :custom-icon-size="'16px'"
        @click="openQuickCard"
      />
      <span>{{ translate('or').toLowerCase() }}</span>
      <ButtonCustom
        class="pointer-events-auto"
        type="important-custom"
        :text="translate('addExistingCard').toLowerCase()"
        :custom-icon-name="'search-alternative'"
        :custom-icon-size="'16px'"
        @click="openFindCard"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import ButtonCustom from '@/components/elements/ButtonCustom';
import useAddCardsToInEpicBoard from '@/utilities/composables/useAddCardsToInEpicBoard';
import useTranslate from '@/utilities/composables/useTranslate';

const props = defineProps({
  currentBoardId: {
    type: String,
    required: true,
  },
});

const { openQuickCard, openFindCard } = useAddCardsToInEpicBoard(props.currentBoardId);
const { translate } = useTranslate();
</script>

<style>
.epic-board-button {
  padding: 4px 8px;
  height: auto;
  border-radius: 4px;
  margin: 4px 0;
  @apply text-sm;
}
</style>
